import React from 'react'
import WidgetIcon from '../../../Atoms/WidgetIcon/WidgetIcon'
import { ReactComponent as Icon } from './QuickFilterWidget.Icon.svg'

export default () => <WidgetIcon icon={Icon} />
